/**
 * @file
 * Simple helpers for the ymca_tampa_lb theme.
 */

(function ($, Drupal, drupalSettings, once) {

  'use strict';

  /**
   * Override Openy to automatically click next button instead of scrolling.
   */
  Drupal.behaviors.scrollToNext = {
    attach: function (context, settings) {
      once('calcForm', '.calc-block-form', context).forEach(function (form) {
        const $form = $(form);
        $form.find('.membership-type .btn-lg.btn').on('click', function () {
          var $clickedElement = $(this);

          $(context).find('.form-radios .btn-lg.btn').removeClass('btn-success');
          $clickedElement.addClass('btn-success');

          // $('<div class="ajax-progress"><div class="throbber"></div></div>').insertAfter($clickedElement);

          setTimeout(function() {
            $('.calc-block-form .step-1 input.form-submit').mousedown();
          }, 100);
        });
      });
    }
  };
})(jQuery, Drupal, drupalSettings, once);
